import {
  laboratories,
  SAMPLE_ANALYSIS_STATUSES,
  SAMPLE_ANALYSIS_STATUSES_DESC,
} from '@/config/constants';

const sampleDetails = {
  code: {
    key: 'code',
    label: 'analysisCode',
    type: 'text',
    sortable: false,
    minWidth: 230,
  },
  parentCode: {
    key: 'parentCode',
    subtitleKey: 'parentDescription',
    label: 'parentAnalysisCode',
    type: 'text-with-subtitle',
    sortable: false,
    minWidth: 180,
  },
  description: {
    key: 'description',
    label: 'analysisDescription',
    type: 'text',
    sortable: false,
    minWidth: 200,
  },
  labSampleAnalysisStatus: {
    key: 'labSampleAnalysisStatus',
    label: 'status',
    type: 'encoded',
    customClass: true,
    enum: 'labSampleAnalysisStatuses',
    decode: (value) => SAMPLE_ANALYSIS_STATUSES_DESC[value],
    getClassModifier: (value) => SAMPLE_ANALYSIS_STATUSES_DESC[value] || '',
    sortable: false,
    minWidth: 130,
  },
  method: {
    key: 'method',
    label: 'analysisMethod',
    type: 'text',
    sortable: false,
    minWidth: 130,
  },
  expectedDeliveryDate: {
    key: 'expectedDeliveryDate',
    label: 'expectedDeliveryDate',
    type: 'date',
    sortable: false,
    minWidth: 130,
  },
  measure: {
    key: 'measure.description',
    label: 'operationMeasure',
    type: 'text',
    sortable: false,
    minWidth: 130,
  },
  measureValue: {
    key: 'value.measure.description',
    label: 'valueMeasure',
    type: 'text',
    sortable: false,
    minWidth: 130,
  },
  analysisValue: {
    key: 'value.value',
    label: 'value',
    type: 'text',
    sortable: false,
    minWidth: 130,
  },
  analysisStart: {
    key: 'value.analysisStart',
    label: 'analysisStart',
    type: 'date',
    sortable: false,
    minWidth: 130,
  },
  analysisEnd: {
    key: 'value.analysisEnd',
    label: 'analysisEnd',
    type: 'date',
    sortable: false,
    minWidth: 130,
  },
  sequence: {
    key: 'sequence',
    label: 'sequence',
    type: 'text',
    sortable: false,
    minWidth: 130,
  },
  expectedValue: {
    key: 'expectedValue',
    label: 'expectedValue',
    type: 'text',
    sortable: false,
    minWidth: 130,
  },
  LD: {
    key: 'value.LD',
    label: 'LD',
    type: 'text',
    sortable: false,
    minWidth: 130,
  },
  U: {
    key: 'value.U',
    label: 'U',
    type: 'text',
    sortable: false,
    minWidth: 130,
  },
  LQ: {
    key: 'value.LQ',
    label: 'LQ',
    type: 'text',
    sortable: false,
    minWidth: 130,
  },
  recoveryFactor: {
    key: 'value.recoveryFactor',
    label: 'recoveryFactor',
    type: 'text',
    sortable: false,
    minWidth: 130,
  },
  notes: {
    key: 'value.notes',
    label: 'notes',
    type: 'function',
    sortable: false,
    minWidth: 130,
    get: (value) =>
      value && value.length > 20 ? `${value.substring(0, 20)}...` : value,
  },
  actions: {
    key: 'actions',
    label: 'actions',
    type: 'actions',
    sortable: false,
    fixed: true,
    minWidth: 200,
    buttons: [
      {
        name: 'insertMeasuredValue',
        icon: 'fas fa-microscope',
        showCondition: (row) => !row.children,
      },
      {
        name: 'insertMeasuredValueBulk',
        icon: 'fas fa-microscope',
        showCondition: (row) => row.children && row.children.length > 0,
      },
      {
        name: 'createTemperatureTrail',
        icon: 'fas fa-thermometer-half',
        showCondition: (row) => row.laboratory === laboratories.MICR,
      },
      {
        name: 'enableRawData',
        icon: 'fas fa-check-circle',
        showCondition: (row) =>
          !row.children &&
          row.value &&
          row.mainResult &&
          !row.value.showRawData,
      },
      {
        name: 'disableRawData',
        icon: 'fas fa-do-not-enter',
        showCondition: (row) =>
          !row.children && row.value && row.mainResult && row.value.showRawData,
      },
      {
        name: 'associateLocation',
        icon: 'fas fa-building',
        permissions: [],
        showCondition: (row) =>
          row.labSampleAnalysisStatus === SAMPLE_ANALYSIS_STATUSES.ACCEPTED ||
          row.labSampleAnalysisStatus === SAMPLE_ANALYSIS_STATUSES.PENDING,
      },
      {
        name: 'cancelAnalysis',
        icon: 'fas fa-do-not-enter',
        permissions: [],
        showCondition: (row) =>
          row.labSampleAnalysisStatus === SAMPLE_ANALYSIS_STATUSES.ACCEPTED ||
          row.labSampleAnalysisStatus === SAMPLE_ANALYSIS_STATUSES.PENDING ||
          row.labSampleAnalysisStatus === SAMPLE_ANALYSIS_STATUSES.SUSPENDED,
      },
    ],
  },
};

export default sampleDetails;
